import { ICurrencyCode } from "../graphql";
export const CommonCurrencyList = Object.freeze([
    ICurrencyCode.Eur,
    ICurrencyCode.Usd,
    ICurrencyCode.Chf,
    ICurrencyCode.Gbp,
    ICurrencyCode.Sek,
    ICurrencyCode.Czk,
    ICurrencyCode.Pln,
    ICurrencyCode.Nok,
    ICurrencyCode.Jpy,
    ICurrencyCode.Cad,
    ICurrencyCode.Rub,
    ICurrencyCode.Vnd,
]);
//# sourceMappingURL=Currency.js.map